/**
 * Module depenencies.
 */

import { InnovationBlock } from 'src/types/innovation-block';
import countriesSvg from 'src/assets/svg/countries.svg';
import cylindersSvg from 'src/assets/svg/cylinders.svg';
import manufactureSvg from 'src/assets/svg/manufacture.svg';

/**
 * `Config` type.
 */

type Config = {
  innovationBlocks: InnovationBlock[];
};

/**
 * Export `contentConfig`.
 */

export const contentConfig: Config = {
  innovationBlocks: [
    {
      description:
        'human-resources:sections.innovation.blocks.manufacture.description',
      icon: manufactureSvg,
      title: 'human-resources:sections.innovation.blocks.manufacture.title'
    },
    {
      description:
        'human-resources:sections.innovation.blocks.countries.description',
      icon: countriesSvg,
      title: 'human-resources:sections.innovation.blocks.countries.title'
    },
    {
      description:
        'human-resources:sections.innovation.blocks.cylinders.description',
      icon: cylindersSvg,
      title: 'human-resources:sections.innovation.blocks.cylinders.title'
    }
  ]
};
